import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { aiAlertNotificationRulesSelector } from '@src/store/common/selectors';
import GlobalMuteDrawerContent from './GlobalMuteDrawer';
import { StyledDrawer } from './styled';

export const OPEN_GLOBAL_MUTE_EVENT = 'open-global-mute';

const GlobalMutePage = () => {
  const rulesEnabled = useSelector(aiAlertNotificationRulesSelector);
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  useEffect(() => {
    if (!rulesEnabled) return undefined;
    const handleOpenPage = () => {
      setOpenDrawer(true);
    };
    window.addEventListener(OPEN_GLOBAL_MUTE_EVENT, handleOpenPage);
    return () => {
      window.removeEventListener(OPEN_GLOBAL_MUTE_EVENT, handleOpenPage);
    };
  }, [rulesEnabled]);

  // Gated behind the `ai-alert-notification-rules` rollout flag. Per-product
  // eligibility (e.g. `app-experience` for eco) is additionally enforced by the
  // server on every request.
  if (!rulesEnabled) return null;

  return (
    <div data-ifc-event={OPEN_GLOBAL_MUTE_EVENT}>
      <StyledDrawer
        open={openDrawer}
        closeIcon={null}
        styles={{
          wrapper: {
            width: '520px',
            minWidth: '420px',
          },
        }}
        onClose={handleCloseDrawer}
        keyboard
      >
        {openDrawer ? <GlobalMuteDrawerContent closeDrawer={handleCloseDrawer} /> : null}
      </StyledDrawer>
    </div>
  );
};

export default GlobalMutePage;
